import Model from 'src/app/common/model';

export default class FarmTeleHealthModel extends Model {
  messages: Array<IMessages>;
  attachments?: Array<IAttachments>;
  personIDs?: Array<string>;
  farmSiteID?: string;
  personID?: string;
  receiverID?: string;
  unreadCount?: number;
  enterdata?: string;
  message: any;

  constructor() {
    super();
    this.messages = new Array();
  }
}

//////////////////////////////
//IMessages
//////////////////////////////
export class IMessages {
  id?: string;
  date?: Date;
  receiverID?: string;
  senderID?: string;
  messgae?: IMessage;
  createdAt?: Date;
  updatedAt?: Date;

  constructor() {
  }
}

//////////////////////////////
//IMessage
//////////////////////////////
export class IMessage {
  MIMEType: string;
  data: string;

  constructor() {
  }
}

//////////////////////////////
//IAttachments
//////////////////////////////
export class IAttachments {
  id: string;
  createdAt: string;
  updatedAt: string;
  date: string;
  isRead: boolean;
  senderID: string;
  receiverID: string;
  message: IMessage;

  constructor() {
  }
}
